"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeDriveRemoteContent = void 0;
var base_1 = require("./base");
var http_1 = require("../../client/http");
var errors_1 = require("../../../common/errors");
var base64_1 = require("../../../utils/base64");
var compression_1 = require("../../../utils/compression");
var NativeDriveRemoteContent = /** @class */ (function (_super) {
    __extends(NativeDriveRemoteContent, _super);
    function NativeDriveRemoteContent(httpClient, contentName, driveSettings, version, contentUrlBuilder) {
        var _this = _super.call(this, httpClient, contentName, driveSettings, contentUrlBuilder) || this;
        _this.version = version;
        return _this;
    }
    NativeDriveRemoteContent.prototype._prepareContentForRemote = function (specificContent, offset, count, token, p) {
        return __awaiter(this, void 0, void 0, function () {
            var nativeContent, blob, gzipped;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nativeContent = specificContent.content;
                        return [4 /*yield*/, nativeContent.readBlob(offset, count)];
                    case 1:
                        blob = _a.sent();
                        if (!(0, compression_1.isNativeGzipSupported)()) {
                            return [2 /*return*/, new http_1.HttpTransferChunk(blob, this.version)];
                        }
                        return [4 /*yield*/, (0, compression_1.gzip)(blob)];
                    case 2:
                        gzipped = _a.sent();
                        return [2 /*return*/, new http_1.HttpTransferChunk(gzipped, this.version, "gzip")];
                }
            });
        });
    };
    NativeDriveRemoteContent.prototype._transferFromRemoteOptions = function (offset, count) {
        return {
            name: this.contentName,
            count: count,
            offset: offset,
            responseType: "arraybuffer",
        };
    };
    NativeDriveRemoteContent.prototype._transferFromRemote = function (responseFromRemote, sink, sinkOffset, count, token, p) {
        var nativeContent = sink.content;
        var result = responseFromRemote;
        if (Number.isInteger(responseFromRemote.to) &&
            Number.isInteger(responseFromRemote.from)) {
            var expectedSize = responseFromRemote.to - responseFromRemote.from + 1;
            var chunkSize = responseFromRemote.isEncoded
                ? (0, base64_1.getBase64SourceSize)(result.content)
                : result.content.byteLength;
            if (chunkSize !== expectedSize) {
                var details = {
                    actualSize: chunkSize,
                    expectedSize: expectedSize,
                };
                throw new errors_1.CommonError("Received chunk data size does not match expected size.", null, errors_1.ErrorCodes.Mismatch, details);
            }
        }
        if (responseFromRemote.isEncoded) {
            return nativeContent.writeBase64(result.content, responseFromRemote.from);
        }
        return nativeContent.writeBuffer(result.content, responseFromRemote.from);
    };
    return NativeDriveRemoteContent;
}(base_1.BaseDriveRemoteContent));
exports.NativeDriveRemoteContent = NativeDriveRemoteContent;
